'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var op = 0;
function resizeWindow() {

	var welcometxt = $('#home .main-content .intro-content .wrapper').width() - $('#home .main-content .intro-content .benefits').width() - 9;
	$('#home .main-content .intro-content .wrapper .text').width(welcometxt);
	// var reasontxt = $('#home .main-content .home-reasons .wrapper').width() - $('#home .main-content .home-reasons .left-image').width() - 9;
	// $('#home .main-content .home-reasons .reasons-image').width(reasontxt);

	// var mapimg = $('#home .main-content .home-map .wrapper').width() - $('#home .main-content .home-map .map').width() - 8;
	// $('#home .main-content .home-map .image').width(mapimg);

	var mapimg = $('#landing-page .main-content .home-map .wrapper').width() - $('#landing-page .main-content .home-map .map').width() - 8;
	$('#landing-page .main-content .home-map .image').width(mapimg);

	var mapimg = $('#landing-page-new .main-content .home-map .wrapper').width() - $('#landing-page-new .main-content .home-map .map').width() - 8;
	$('#landing-page-new .main-content .home-map .image').width(mapimg);

	var wedimg = $('#home .main-content .home-events .wrapper').width() - $('#home .main-content .home-events .events').width() - 8;
	$('#home .main-content .home-events .weddings').width(wedimg);

	// var contentH = $('#content #top-content .header-img').outerWidth() - $('#content #top-content .header-img .left-image').width() - 8;
	// $('#content #top-content .header-img').width(contentH);

	// var roomfeature = $('#content .shortcode .featured-room .back').outerWidth() - $('#content .shortcode .back .left-image').width() - 8;
	// $('#content .shortcode .back .right-image').width(roomfeature);

	// var dividing = $('#content #bottom-content .shortcode .divided .wrapper').outerWidth() - $('#bottom-content .divided .left-image').width() - 148;
	// $('#bottom-content .divided .rigth-info').width(dividing);

	if ($(window).width() > 800) {

		var menuWidth = $('#header .container').width() - $('#header .logo').width() - 35;
		$('#home #header #primary-nav').width(menuWidth);

		var insetimg = $('#content #bottom-content .copy .wrapper').width() - $('#content #bottom-content .inset-image').width() - 148;
		$('#content #bottom-content .copy .wrapper .text').width(insetimg);

		$('#home .top-content .header-img .sym-slide img').css('height', 'auto');
	} else {
		// var dividing = $('#content #bottom-content .shortcode .divided .wrapper').outerWidth() - $('#bottom-content .divided .left-image').width() - 88;
		// $('#bottom-content .divided .rigth-info').width(dividing);

		var insetimg = $('#content #bottom-content .copy .wrapper').width() - $('#content #bottom-content .inset-image').width() - 48;
		$('#content #bottom-content .copy .wrapper .text').width(insetimg);

		$('#home .top-content .header-img .sym-slide img').height($(window).height());
	}
}
function scrollDown() {
	var top = $(document).scrollTop();
	if (top > 50) {
		$('#home #header').addClass('down');
	} else {
		$('#home #header').removeClass('down');
	}
}

function _get_form_token() {
	$.get(site_url + '/ajax/functions.php?operation=_get_form_token', function (resp) {
		$("input[name=_token][type=hidden]").each(function () {
			this.value = resp;
		});
	});
}

$(document).ready(function () {

	_get_form_token();

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});

	if ($('.equilize')) {
		equalize();
	}

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
		if ($('.booking-block').hasClass('open')) {
			$('header .top .btn').removeClass('open');
			$('.booking-block').removeClass('open');
		}
	});

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	$('#header .bottom .bars').click(showFullMenu);

	$('.open-booking-widget-inline-date').on('click', function (e) {
		$("#adults").val(2);
		$("#child").val(0);
		$("#number_guest").text("2 ADULTS");
	});
	//HOME

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() * 2 }, 800, 'easeOutExpo');
	});
	//Revinate stars
	if ($('body#home').length > 0) {
		var rate = 100 * parseFloat($('.stars .average').html()) / 5;
		$('.stars .average').css('width', rate + '%');
		// console.log(rate);
	}
	//home map
	$('#home .main-content .home-map .map .pin').click(function () {
		var current = $(this).attr('data');
		$('#home .main-content .home-map .map .pin').removeClass('active');
		$(this).addClass('active');
		$('#home .main-content .home-map .info .pin').removeClass('active');
		$('#home .main-content .home-map .info .pin[data="' + current + '"]').addClass('active');
	});

	//LANDING map
	$('#landing-page .main-content .home-map .map .pin').click(function () {
		var current = $(this).attr('data');
		$('#landing-page .main-content .home-map .map .pin').removeClass('active');
		$(this).addClass('active');
		$('#landing-page .main-content .home-map .info .pin').removeClass('active');
		$('#landing-page .main-content .home-map .info .pin[data="' + current + '"]').addClass('active');
	});
	///Landing New
	$('#landing-page-new .main-content .home-map .map .pin').click(function () {
		var current = $(this).attr('data');
		$('#landing-page-new .main-content .home-map .map .pin').removeClass('active');
		$(this).addClass('active');
		$('#landing-page-new .main-content .home-map .info .pin').removeClass('active');
		$('#landing-pag-new .main-content .home-map .info .pin[data="' + current + '"]').addClass('active');
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
	});

	$("#CheckIn-2f").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		// minDate: new Date(2017, 10, 27),
		// maxDate: new Date(2018, 02, 16),
		dateFormat: 'yy-mm-dd',
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 3);
			$("#CheckOut-2f").datepicker("setDate", newDate);
			$("#CheckOut-2f").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut-2f").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		// minDate: new Date(2017, 10, 27),
		// maxDate: new Date(2018, 02, 16),
		dateFormat: 'yy-mm-dd',
		onSelect: function onSelect(selectedDate) {
			//$( "#CheckIn-2f" ).datepicker( "option", "maxDate", selectedDate );
		}
	});

	$(".selector").datepicker({
		numberOfMonths: 2,
		minDate: 0
	});

	$('#booking-form').submit(function (event) {

		/*event.preventDefault();
  var clientId;
  var promoCode = jQuery(this).find('[name="promo_code"]').val();
  var checkIn = jQuery(this).find('[name="booking-checkin"]');
  var checkOut = jQuery(this).find('[name="booking-checkout"]');
  var checkInVal = checkIn.val();
  var checkOutVal = checkOut.val();
  var checkInArray = checkInVal.split('/');
  var checkOutArray = checkOutVal.split('/');
  var checkInYear = checkInArray[2];
  var checkInMonth = parseInt(checkInArray[0]) - 1;
  var checkInMonthAdj = checkInArray[0];
  var checkInDay = checkInArray[1];
  var checkOutYear = checkOutArray[2];
  var checkOutMonth = parseInt(checkOutArray[0]) - 1;
  var checkOutDay = checkOutArray[1];
  
  var adults = jQuery(this).find('[name="adults"]').val();
  var children = jQuery(this).find('[name="children"]').val();
  //calculate number of days chosen
  var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
  var checkInDate = new Date(checkInYear,checkInMonth,checkInDay);
  var checkOutDate = new Date(checkOutYear,checkOutMonth,checkOutDay);		
  var numDays = Math.round(Math.abs((checkInDate.getTime() - checkOutDate.getTime())/(oneDay)));
  //validation
  if (checkInDate >= checkOutDate) {
  	alert('Your Check-out day must be after your Check-in day. Please check your selection and try again.');
  	return false;
  }*/

		ga(function (tracker) {
			clientId = tracker.get('linkerParam');
		});

		//console.log('checkInDay ' + checkInDay + ' checkInMonthAdj ' + checkInMonthAdj + ' checkInYear '+ checkInYear + ' numDays '+ numDays)
		//go to booking URL
		// var bookingURL = 'https://www.bookonthenet.net/east/premium/eresmain.aspx?id=goACFFmMRTTiPpX5%2bn3VYtYzvK30hg9Y4LD0iMa4KXQ%3d&arrival_date='+ checkInYear + '-' + checkInMonthAdj + '-' + checkInDay +'&stay_nights='+ numDays +'&promo_code=' + promoCode +'&adults='+adults+'&children='+children+'&' + clientId;
		//var bookingURL = 'https://reservations.travelclick.com/95046?&' + checkInYear + '-' + checkInMonthAdj + '-' + checkInDay +'&stay_nights='+ numDays +'&promo_code=' + promoCode +'&adults='+adults+'&children='+children+'&' + clientId;

		//window.open(bookingURL, '_blank');
	});

	$('#WeddingLead').submit(function (event) {
		$('.field, .form-entry').each(function () {
			var placeholder = $(this).find('label').text();
			$(this).find('input').attr('placeholder', placeholder);
			$(this).find('textarea').attr('placeholder', placeholder);
		});
	});

	//shortcodes to remove from copy
	if ($('#content .shortcode').length > 0) {
		$('#content .shortcode').insertAfter($('#content .copy'));
	}
	//shortcodes up to move upfrom copy
	if ($('#content .shortcode-up').length > 0) {
		$('#content .shortcode-up').insertAfter($('#content .intro'));
	}

	//Forms
	$('form a.btnSubmit').addClass('large');

	//booking widget slider animation
	if ($('body#home').length > 0) {
		setTimeout(function () {
			$('#booking-menu').addClass('shown');
		}, 1000);
	} else {
		setTimeout(function () {
			$('#booking-menu').addClass('shown');
		}, 1000);
	};

	//Offers terms and info trigger
	$('.reservation-includes').click(showFSpecial);

	/*ON SCROLL CONTENT ANIMATION*/
	setTimeout(function () {
		var controller = new ScrollMagic.Controller();
		if ($('.cicle_one').length > 0) {
			$('.cicle_one').each(function () {
				// build a scene
				var ourScene = new ScrollMagic.Scene({
					triggerElement: this.children[0],
					triggerHook: 0.9,
					reverse: false
				}).setClassToggle(this, 'fade-in').addTo(controller);
			});
		}
	}, 600);
	setTimeout(function () {
		var controller = new ScrollMagic.Controller();
		if ($('.cicle_two').length > 0) {
			$('.cicle_two').each(function () {
				// build a scene
				var ourScene = new ScrollMagic.Scene({
					triggerElement: this.children[0],
					triggerHook: 0.9,
					reverse: false
				}).setClassToggle(this, 'fade-in').addTo(controller);
			});
		}
	}, 1500);
	setTimeout(function () {
		var controller = new ScrollMagic.Controller();
		if ($('.cicle_three').length > 0) {
			$('.cicle_three').each(function () {
				// build a scene
				var ourScene = new ScrollMagic.Scene({
					triggerElement: this.children[0],
					triggerHook: 0.9,
					reverse: false
				}).setClassToggle(this, 'fade-in').addTo(controller);
			});
		}
	}, 2400);
	setTimeout(function () {
		var controller = new ScrollMagic.Controller();
		if ($('.cicle_four').length > 0) {
			$('.cicle_four').each(function () {
				// build a scene
				var ourScene = new ScrollMagic.Scene({
					triggerElement: this.children[0],
					triggerHook: 0.9,
					reverse: false
				}).setClassToggle(this, 'fade-in').addTo(controller);
			});
		}
	}, 3600);

	$('#content .showForm').click(function () {
		$('.rfp-form').slideDown(600);
		//$('#content .rfp-form .btn.yellow').fadeOut(800);
	});

	if ($('body.groups-and-events:not(.groups)').length > 0 && $('body.groups-and-events:not(.meetings-and-events)').length > 0 && $('body.groups-and-events:not(.weddings)').length > 0) {
		$('table').wrap('<div class="table"><div class="container"></div></div>');
		$('.table').insertAfter('#rfpForm');
		$('#content #bottom-content .shortcode').insertAfter($('#content #bottom-content .intro'));
	}

	//Experiences template
	if ($('body#experiences-new').length > 0) {
		$('article:first-of-type').addClass('active');
		$('.list button:first-child').addClass('active');
		$('.slideI:first-child').addClass('active');

		// $('.events-block a').click(function(e){
		//     e.preventDefault();
		//     var currentL = $(this).attr('href');
		//     var target = $(currentL).offset().top - 150;
		//     $('html, body').animate({
		//         scrollTop: target},
		//         1500, 'easeOutExpo', function(){

		//     });

		// });

		$('.events-block a').click(function (e) {
			e.preventDefault();
			var currentL = $(this).attr('href');
			if (currentL.startsWith('#')) {
				var target = $(currentL).offset().top - 150;
				$('html, body').animate({
					scrollTop: target
				}, 1500, 'easeOutExpo');
			} else {
				window.location.href = currentL;
			}
		});

		$('.text .list button').click(function () {
			var currentdata = $(this).attr('data');
			$(this).parent().find('button').removeClass('active');
			$(this).parents().eq(1).find('article').removeClass('active');
			$(this).parents().eq(3).prev().find('.slideI').removeClass('active');
			$('#golf .image .slideI').removeClass('active');
			$(this).addClass('active');
			$('#golf .image .slideI[data="' + currentdata + '"]').addClass('active');
			$(this).parents().eq(1).find('article[data="' + currentdata + '"]').addClass('active');
			$(this).parents().eq(3).prev().find('.slideI[data="' + currentdata + '"]').addClass('active');
		});
	}
	//Experiences-new  template
	if ($('body#experiences').length > 0) {
		$('article:first-of-type').addClass('active');
		$('.list button:first-child').addClass('active');
		$('.slideI:first-child').addClass('active');

		// $('.events-block a').click(function(e){
		//     e.preventDefault();
		//     var currentL = $(this).attr('href');
		//     var target = $(currentL).offset().top - 150;
		//     $('html, body').animate({
		//         scrollTop: target},
		//         1500, 'easeOutExpo', function(){

		//     });

		// });

		$('.events-block a').click(function (e) {
			e.preventDefault();
			var currentL = $(this).attr('href');
			if (currentL.startsWith('#')) {
				var target = $(currentL).offset().top - 150;
				$('html, body').animate({
					scrollTop: target
				}, 1500, 'easeOutExpo');
			} else {
				window.location.href = currentL;
			}
		});

		$('.text .list button').click(function () {
			var currentdata = $(this).attr('data');
			$(this).parent().find('button').removeClass('active');
			$(this).parents().eq(1).find('article').removeClass('active');
			$(this).parents().eq(3).prev().find('.slideI').removeClass('active');
			$('#golf .image .slideI').removeClass('active');
			$(this).addClass('active');
			$('#golf .image .slideI[data="' + currentdata + '"]').addClass('active');
			$(this).parents().eq(1).find('article[data="' + currentdata + '"]').addClass('active');
			$(this).parents().eq(3).prev().find('.slideI[data="' + currentdata + '"]').addClass('active');
		});
	}

	//limits
	$('body#experiences #content #bottom-content .copy .section .image+.text, #content #bottom-content .copy .wrapper .text .wrap').wrapInner('<div class="limit"></div>');

	//getting here

	if ($('body.getting-here').length > 0) {
		$('.full-text').insertAfter($('.shortcode-up .col-md-6'));
		$('.full-text').addClass('col-md-6');
	}

	//phone
	$('a.phone').each(function () {
		var phonet = $(this).html();
		var newhref = phonet.replace('(', '').replace(')', '').replace(' ', '');
		$(this).attr('href', 'tel:' + newhref);
	});

	// Map: Return to previous page button. Change body id to match map template's name.
	$('body.interactive-map #content').prepend('<a class="btn return-from-map yellow" href="javascript:history.back()">« Back to previous page</a>');

	$('form .btn.btnSubmit').click(function () {

		//pixel facebook
		//fbq('track', 'WeddingLead');

		setTimeout(function () {

			$('p#thankyou').fadeOut(500);
		}, 6000);
	});

	//Slick Slider
	$('.sym-slides').slick();
});

$(window).on('load', function () {
	var _$$slick;

	resizeWindow();
	scrollDown();

	if (!$('body#home').length > 0) {
		$('#header').addClass('down');
	}

	$('#home .main-content .home-reasons .reasons-image').slick({
		arrows: false,
		fade: true,
		asNavFor: '#home .main-content .home-reasons .container .block',
		accessibility: false
	});

	$('#landing-page .main-content .home-reasons .reasons-image').slick({
		arrows: false,
		fade: true,
		asNavFor: '#landing-page .main-content .home-reasons .container .block',
		accessibility: false
	});

	$('#landing-page-new .main-content .home-reasons .reasons-image').slick({
		arrows: false,
		fade: true,
		asNavFor: '#landing-page-new .main-content .home-reasons .container .block',
		accessibility: false
	});

	$('#home .main-content .home-reasons .container .block').slick({
		arrows: false,
		dots: true,
		fade: true,
		asNavFor: '#home .main-content .home-reasons .reasons-image',
		accessibility: false
	});

	$('#landing-page .main-content .home-reasons .container .block').slick({
		arrows: false,
		dots: true,
		fade: true,
		asNavFor: '#landing-page .main-content .home-reasons .reasons-image',
		accessibility: false
	});

	$('#landing-page-new .main-content .home-reasons .container .block').slick({
		arrows: false,
		dots: true,
		fade: true,
		asNavFor: '#landing-page-new .main-content .home-reasons .reasons-image',
		accessibility: false
	});

	$('#home .home-testimonials .quotes').slick({
		arrows: false,
		fade: true,
		dots: true,
		accessibility: false
	});

	$('#landing-page .home-testimonials .quotes').slick({
		arrows: false,
		fade: true,
		dots: true,
		accessibility: false
	});
	$('#landing-page-discount .home-testimonials .quotes').slick({
		arrows: false,
		fade: true,
		dots: true,
		accessibility: false
	});

	$('#landing-page-new .home-testimonials .quotes').slick({
		arrows: false,
		fade: true,
		dots: true,
		accessibility: false
	});

	$('.gallery .wrapper').slick((_$$slick = {
		arrows: true
	}, _defineProperty(_$$slick, 'arrows', true), _defineProperty(_$$slick, 'slidesToShow', 5), _defineProperty(_$$slick, 'slidesToScroll', 1), _defineProperty(_$$slick, 'accessibility', false), _$$slick));

	$('#home .main-content .home-dining .container .images .block').slick({
		arrows: false,
		dots: true,
		fade: true,
		autoplay: true,
		autoplaySpeed: 6000,
		accessibility: false
	});

	$('#content #bottom-content .copy .inset-image').slick({
		arrows: false,
		dots: true,
		fade: true,
		autoplay: true,
		autoplaySpeed: 6000,
		accessibility: false
	});

	$("#emailSignupGuestFolio").click(function () {
		$.post(site_url + 'ajax/guestfolio.php', $("#email-signup").serialize(), function (data) {
			if (data.error) {
				$("#email-error").html(data.msg);
			} else {

				$('#email-signup').find("input[type=text]").val("");
				$("#email-signup").slideUp('fast');
				$("#email-error").html('Thank you for joining our list to receive exclusive news and offers.');
				$("#email-error").show();
			}
		}, 'json');

		if (IS_LIVE) ga('send', 'event', 'form', 'form submission', 'specials');
	});
});

function showFullMenu() {
	$(this).addClass('open');
	$(this).unbind('click');
	if (op == 0) {
		$('#header #primary-nav').wrapInner('<div class="table"></div>');
		op = 1;
	}
	var Fheight = $(window).height() - 139;
	$('#header #primary-nav').height(Fheight);
	$('#header #primary-nav').fadeIn(500);

	if (!$('#home #header').hasClass('down')) {
		$('#home #header').addClass('down');
	}

	$(this).click(hideFullMenu);
}
function hideFullMenu() {
	$(this).removeClass('open');
	if ($(document).scrollTop() < 50) {
		$('#home #header').removeClass('down');
	}
	$('#header #primary-nav').fadeOut(500);
	$(this).unbind('click');
	$(this).click(showFullMenu);
}

function showFSpecial() {
	$(this).addClass('open');
	$(this).next().slideDown(600);
	$(this).unbind('click');
	$(this).click(hideFSpecial);
}
function hideFSpecial() {
	$(this).removeClass('open');
	$(this).next().slideUp(600);
	$(this).unbind('click');
	$(this).click(showFSpecial);
}

$('.tags-menu select').change(function () {
	var thisTag = $(this).val();
	$('.room, .tag-text').hide();
	$('.tag-' + thisTag + ', .tag-text-' + thisTag).fadeIn();
	$('.tags-menu .tag-link').removeClass('active');
	$(this).addClass('active');
});

$('.tags-menu .tag-link').click(function () {
	var thisTag = $(this).attr('data-tag');
	$('.room, .tag-text').hide();
	$('.tag-' + thisTag + ', .tag-text-' + thisTag).fadeIn();
	$('.tags-menu .tag-link').removeClass('active');
	$('.tags-menu .tag-link').attr('aria-selected', 'false');
	$(this).addClass('active');
	$(this).attr('aria-selected', 'true');
});

if (document.querySelector('#footer button.signup-btn')) {
	var button = document.querySelector('#footer button.signup-btn');
	button.setAttribute('aria-label', 'subscribe to our email database');
}
document.addEventListener('DOMContentLoaded', function () {

	document.querySelectorAll('[data-getrooms]').forEach(function (btn, i) {
		btn.addEventListener('click', function () {

			document.querySelectorAll('.roomsTabs_navItem').forEach(function (b) {
				return b.classList.remove('active');
			});
			document.querySelectorAll('.roomsTabs_navItem').forEach(function (b) {
				return b.setAttribute('aria-selected', 'false');
			});
			btn.classList.add('active');
			btn.setAttribute('aria-selected', 'true');
		});

		if (i === 0) btn.click();
	});
});

/*** GROUPS CTA FORMS DEPLOYMENT ***/

document.addEventListener('DOMContentLoaded', function () {

	if (document.getElementsByClassName('js-slideform').length > 0) {

		document.querySelectorAll('.js-slideform').forEach(function (btn) {

			btn.addEventListener('click', function (e) {

				e.preventDefault();
				if (document.querySelectorAll('.form-container').length > 0) {
					document.querySelectorAll('.form-container').forEach(function (form) {
						return form.classList.add('hidden');
					});
				}

				var currentTarget = this.getAttribute('href').split('#')[1];
				if (document.getElementById(currentTarget)) {
					document.getElementById(currentTarget).classList.remove('hidden');
				}
				if (document.querySelector('.js-catering-btn')) {
					document.querySelector('.js-catering-btn').classList.remove('hidden');
				}
			});
		});
	}
	if (document.querySelectorAll('.js-closeform').length > 0) {
		document.querySelectorAll('.js-closeform').forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				var currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('hidden');
				if (document.querySelector('.js-catering-btn')) {
					document.querySelector('.js-catering-btn').classList.add('hidden');
				}
			});
		});
	}

	// // const groupsProposalCTA = document.querySelector('.js-univ-groups-form');
	// // const groupsProposalForm = document.getElementById('requestforuniversitygroupsproposal-form');

	// // const transientProposalCTA = document.querySelector('.js-univ-transient-form');	
	// // const transientProposalForm = document.getElementById('reservationrequestform-form');

	// const cateringForm = document.querySelector('.js-catering-btn');	

	// if(cateringForm){
	// 	cateringForm.classList.add('hidden');
	// }	

	// function createButton(form){
	// 	const closeButton = document.createElement('button');
	// 	closeButton.classList.add('close-btn');
	// 	closeButton.textContent = 'X';
	// 	closeButton.addEventListener('click', () => {
	// 		form.classList.add('hidden');
	// 	});
	// 	form.appendChild(closeButton);
	// }

	// function toggleFormVisibility(formOne, formTwo){
	// 	if(!formTwo.classList.contains('hidden')) {
	// 		formTwo.classList.add('hidden');
	// 	}
	// 	formOne.classList.toggle('hidden');
	// }

	// function updateCateringFormVisibility(){
	// 	if(cateringForm){
	// 		if(transientProposalForm.classList.contains('hidden') && groupsProposalForm.classList.contains('hidden')){
	// 			cateringForm.classList.add('hidden');
	// 		} else {
	// 			cateringForm.classList.remove('hidden');
	// 		}
	// 	}
	// }

	// if(groupsProposalForm && transientProposalForm){
	// 	createButton(groupsProposalForm);
	// 	createButton(transientProposalForm);
	// }

	// if(groupsProposalCTA && groupsProposalForm) {
	// 	groupsProposalForm.classList.add('hidden');
	// 	groupsProposalCTA.addEventListener('click', () => {
	// 		toggleFormVisibility(groupsProposalForm, transientProposalForm);
	// 		updateCateringFormVisibility();
	// 	})
	// }

	// if(transientProposalCTA && transientProposalForm) {		
	// 	transientProposalForm.classList.add('hidden');
	// 	transientProposalCTA.addEventListener('click', () => {
	// 		toggleFormVisibility(transientProposalForm, groupsProposalForm);
	// 		updateCateringFormVisibility();
	// 	})
	// }
});
//  window.addEventListener('DOMContentLoaded', () => {
// 	 if(document.querySelector( "[name=disabled_welcome_email]" ) ) {
// 		 let hiddenvalue = document.querySelector( "[name=disabled_welcome_email]" )
// 		 hiddenvalue.value = 1;
// 		 hiddenvalue.setAttribute('value',1)
// 	 }
//  })